//b4EmissionFactors
export const gases = ["co2", "ch4", "n2o"];
export const frameworks = ["Fuel EU"];
//b1
export const createB1Payload = (data = {}, mode) => ({
    shipName: mode === "Create" ? data.VesselName : data.shipName ?? "",
    imoNumber: mode === "Create" ? data.ImoNumber : data.imoNumber ?? "",
    portOfRegistry: mode === "Create" ? data.PortCodeMst?.PortName : data.portOfRegistry ?? "",
    homePort: data.homePort || "",
    shipOwnerName: data.shipOwnerName || "",
    shipOwnerTaxNumber: data.shipOwnerTaxNumber || "",
    shipOwnerContactPerson: data.shipOwnerContactPerson || "",
    businessAddress: data.businessAddress || "",
    city: data.city || "",
    stateProvinceRegion: data.stateProvinceRegion || "",
    businessTelephone: data.businessTelephone || "",
    businessEmail: data.businessEmail || "",
    registeredOwnerIMO: data.registeredOwnerIMO || "",
    registeredOwnerCountry: data.registeredOwnerCountry || "",
    shipType: mode === "Create" ? data?.MrvVesselTypeMst?.Code : data.shipType ?? "",
    shipSubType: data.shipSubType || "",
    deadweight:
        mode === "Create" ? data.DeadWeight : data.deadweight !== undefined ? Number(data.deadweight) : null,
    grossTonnage:
        mode === "Create" ? data.GrossTonnage : data.grossTonnage !== undefined ? Number(data.grossTonnage) : null,
    classificationSociety: data.classificationSociety || "",
    iceClass: mode === "Create" ? data?.IceClassMst?.Value : data.iceClass ?? "",
    isIceClassShip: mode === "Create" ? data.IceClassMstId ? true : false : data.isIceClassShip || false,
    flag: mode === "Create" ? data?.PortCodeMst?.CountryName : data.flag || "",
    technicalEfficiency:
        mode === "Create" ? data?.VesselTechnicalEfficiencyDtls?.TechnicalEfficiencyMstId : data.technicalEfficiency ?? "",
    technicalEfficiencyValue:
  mode === "Create" 
    ? parseFloat(data?.VesselTechnicalEfficiencyDtls?.TechnicalEfficiencyText) || 0
    : parseFloat(data.technicalEfficiencyValue) || 0,
    additionalInformation: data.additionalInformation || "",
    businessPrinciplePlace:data.businessPrinciplePlace || "",
   
});
export const commonFormFields = [
  { label: "Reference to existing procedure", name: "referenceToProcedure", maxLength: 1000 },
  { label: "Version of existing procedure", name: "versionOfProcedure", maxLength: 1000 },
  {
    label: "Description of procedures (a brief description of the procedure can be provided if already existing outside the monitoring plan)",
    name: "descriptionOfProcedure",
    maxLength: 4000,
  },
  {
    label: "Name of person or position responsible for this procedure",
    name: "responsiblePersonOrPosition",
    maxLength: 1000,
  },
  { label: "Location where records are kept", name: "recordLocation", maxLength: 1000 },
  { label: "Name of IT system used (where applicable)", name: "itSystemName", maxLength: 1000 },
];
export const FeuB6FormFields = [
    { label: "Established total electrical power demand of the ship at berth (kW)", name: "totalElectricalPower", type:"number", inputMode:"decimal",step:0.01,},
    { label: "Data Source", name: "dataSource", maxLength: 1000, type:"text"},  
];

export const createB7Payload = [
    { label: "WAPS Reference no.", name: "wapsReferenceNo", maxLength: 1000 },
    { label: "WAPS Type", name: "wapsType", type: "dropdown" },
    { label: "WAPS Name", name: "wapsName", maxLength: 1000, },
    { label: "Pwind", name: "pWind", maxLength: 1000, },
    { label: "Pprop", name: "pProp", maxLength: 1000, },
    { label: "Technical description of WAPS equipement", name: "technicalDescriptionOfWapsEquipment", maxLength: 1000, },

]
export const FuelEuDCommonTableColumns = [
    {
        label: "Back-up monitoring method",
        name: "backupMonitoringMethod",
        type: "dropdown"
    },
    {
        label: "Formulae used",
        name: "formulaeUsed",
        maxLength: 4000,
    },
    {
        label: "Description of method to estimate fuel consumption",
        name: "methodDescription",
        maxLength: 4000,
    },
    {
        label: "Name of person or position responsible for this method",
        name: "responsiblePersonOrPosition",
        maxLength: 1000,
    },
    {
        label: "Data sources",
        name: "dataSources",
        maxLength: 1000,
    },
    {
        label: "Location where records are kept",
        name: "recordLocation",
        maxLength: 1000,
    },
    {
        label: "Name of IT system used (where applicable)",
        name: "itSystemName",
        maxLength: 1000,
    }
]

export const FeuECommonColumns = [
    { label: "Reference to existing procedure", name: "referenceToProcedure", maxLength: 1000 },
    { label: "Version of existing procedure", name: "versionOfProcedure", maxLength: 1000 },
    {
        label: "Description of procedures (a brief description of the procedure can be provided if already existing outside the monitoring plan)",
        name: "descriptionOfProcedure",
        maxLength: 4000
    },
    { label: "Name of person or position responsible for this procedure", name: "responsiblePersonOrPosition", maxLength: 1000 },
    { label: "Location where records are kept", name: "recordLocation", maxLength: 1000 },
    { label: "Name of IT system used (where applicable)", name: "itSystemName", maxLength: 1000 }
];

export const C1Column = [
    {
        label: "Minimum number of expected voyages per reporting period falling under the scope of Regulation (EU) 2015/757 according to the ship’s schedule",
        name: "minimumNumberOfVoyages",
        maxLength: 1000,
    },
    {
        label: "Are there expected voyages per reporting period not falling under the scope of Regulation (EU) 2015/757 according to the ship’s schedule?",
        name: "expectedVoyagesUnderScope",
        type: "dropdown"
    },
    {
        label: "Conditions of Article 9(2) of Regulation (EU) 2015/757 fulfilled?",
        name: "regultionCondition",
        type: "dropdown"
    },
    {
        label: "If yes, do you intend to make use of the derogation for monitoring the amount of fuel consumed on a per-voyage basis?. Please note that monitoring on a per-voyage basis of certain information may be required under Part C, point 2, of Annex II to Regulation (EU) 2015/757 to benefit from the derogation provided for in Articles 12(3-d) to 12(3-b) of Directive 2003/87/EC.",
        name: "useOfDerogation",
        type: "dropdown"
    },

]

export const c3Fields = [
    { label: "Reference to existing procedure", name: "referenceToProcedure", maxLength: 1000 },
    { label: "Version of existing procedure", name: "versionOfProcedure", maxLength: 1000 },
    {
        label:
            "Description of procedures",
        name: "descriptionOfProcedure",
        maxLength: 4000
    },
    { label: "Data sources", name: "dataSources", maxLength: 1000 },
    { label: "Location where records are kept", name: "recordLocation", maxLength: 1000 },
    { label: "Name of IT system used (where applicable)", name: "itSystemName", maxLength: 1000 },
];
export const c42Fields = [
    { label: "Reference to existing procedure", name: "referenceToProcedure", maxLength: 1000 },
    { label: "Version of existing procedure", name: "versionOfProcedure", maxLength: 1000 },
    {
        label: "Description of procedure (including recording and managing distance and winter conditions information. A brief description of the procedure can be provided if already existing outside the monitoring plan)",
        name: "descriptionOfProcedure",
        maxLength: 4000
    },
    { label: "Name of person or position responsible for this procedure", name: "responsiblePersonOrPosition", maxLength: 1000 },
    { label: "Data sources", name: "dataSources", maxLength: 1000 },
    { label: "Location where records are kept", name: "recordLocation", maxLength: 1000 },
    { label: "Name of IT system used (where applicable)", name: "itSystemName", maxLength: 1000 }
];

export const c34Fields = [
    { label: "Reference to existing procedure", name: "referenceToProcedure", maxLength: 1000 },
    { label: "Version of existing procedure", name: "versionOfProcedure", maxLength: 1000 },
   
    {
        label: "Description of procedure (including recording and managing port departure and arrival information) (A brief description of the procedure can be provided if already existing outside the monitoring plan)",
        name: "descriptionOfProcedure",
        maxLength: 4000
    },
    { label: "Name of person or position responsible for this procedure", name: "responsiblePersonOrPosition", maxLength: 1000 },
    { label: "Formulae and data sources", name: "formulaeAndDataSources", maxLength: 1000 },
    { label: "Location where records are kept", name: "recordLocation", maxLength: 1000 },
    { label: "Name of IT system used (where applicable)", name: "itSystemName", maxLength: 1000 }
];

export const REQUIRED_FIELDS_FOR_B1 = [
    "shipName",
    "imoNumber",
    "shipOwnerName",
    "businessAddress",
    "registeredOwnerCountry",
    "flag",
    "shipType",
    "isIceClassShip",
    "iceClass"
]

export const REQUIRED_FIELDS_FOR_B2 = [
    "companyName",
    "companyNatures"
]

export const AUTOSAVE_SUCCESS_MESSAGE = "Your changes have been saved automatically."

export const tabs = ["MP PARTICULARS", "BASIC DATA", "ACTIVITY DATA", "DATA GAPS", "MANAGEMENT", "FURTHER INFORMATION"];